export default __webpack_public_path__ + "static/media/CEV_Ops.aa27b6ee.jpg";